import React, { useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { PurchaseTypes } from 'Redux/purchases'
import { hasPendingToReceiveOrders } from 'Components/utils/order'

import { OrderPRCounter } from './styled'

const PRCounterBullet = () => {
  const dispatch = useDispatch()

  const center = useSelector(({ auth }) => auth.selectedCenter)

  const pendingReceptionOrders = useSelector(state => state.purchase.pendingReceptionOrders)

  useEffect(() => {
    if (!isEmpty(center)) {
      dispatch({
        type: PurchaseTypes.FETCH_PR_ORDERS,
      })
    }
  }, [center, dispatch])

  return hasPendingToReceiveOrders(pendingReceptionOrders) && <OrderPRCounter>{pendingReceptionOrders}</OrderPRCounter>
}

export default PRCounterBullet
